import client from '../../client'
import { Karte, KarteMeMeta, UpdateKarteParams } from './types'
import { ApiResponse } from '../../types'

export * from './types'

export const me = async () => {
  const { data, meta }: ApiResponse<Karte, KarteMeMeta> = await client.get(
    '/user/kartes/me'
  )
  return { data, meta }
}

export const update = async (params: UpdateKarteParams) => {
  return await client.put('/user/kartes', params)
}
